import Session from 'records/Session';
import {
    UPDATE_AUTH_STATUS,
    SET_SESSION_LOADING_STATUS,
} from 'actions/session';
import { FETCH_SOURCE } from 'constants/storeStates';

const initialState = new Session();

const actionsMap = {
    [UPDATE_AUTH_STATUS]: (state, action) => state.merge({
        authenticated: action.data.authenticated,
        source: FETCH_SOURCE.ACTION,
        loading: false,
    }),
    [SET_SESSION_LOADING_STATUS]: (state, action) => state.merge({
        loading: action.data.loading,
    }),
};

export default function session(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}
